import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { reduxKey } from './constants';
import { ACTION_TYPE_INITIALIZE } from './actionTypes';
const actionHandlers = {
    [ACTION_TYPE_INITIALIZE]: (state, action)=>_object_spread({}, state, action.config)
};
const reducers = {
    [reduxKey]: (state = {}, action)=>{
        if (!actionHandlers[action.type]) {
            return state;
        }
        return actionHandlers[action.type](state, action);
    }
};
export default reducers;
